module.exports = __webpack_public_path__ + "img/logo.89d61b45.png";